module.exports = __webpack_public_path__ + "img/eye.4ae4d429.svg";